import React from "react";
import { IoMdStarOutline, IoMdStarHalf, IoMdStar } from "react-icons/io";

const StarRating = ({ field, form }) => {
  const { name, value } = field;

  const handleRating = (rating) => {
    form.setFieldValue(name, rating); // Update Formik form value
  };

  return (
    <div style={{ display: "flex", fontSize: "2rem", cursor: "pointer" }}>
      {[1, 2, 3, 4, 5].map((star) => {
        const halfStar = star - 0.5;

        return (
          <span key={star} style={{ position: "relative", display: "inline-block" }}>

            <span className="stars" onClick={() => handleRating(halfStar)} style={{ position: "absolute", width: "100%" }}>
              {value >= halfStar ? <IoMdStarHalf className="f" /> : <IoMdStarOutline className="l" />}
            </span>

            <span className="stars" onClick={() => handleRating(star)}>
              {value >= star ? <IoMdStar className="f" /> : <IoMdStarOutline className="l" />}
            </span>
          </span>
        );
      })}
    </div>
  );
};

export default StarRating;
